import {atom, useAtom} from 'jotai';

export const ongoingAddToCartServerSideCountAtom = atom<number>(-1);

export const useTrackingOngoingAddToCartServerSide = () => {
    const [ongoingAddToCartServerSideCount, SetOngoingAddToCartServerSideCount] = useAtom(
        ongoingAddToCartServerSideCountAtom,
    );

    const increaseOngoingCall = () => {
        SetOngoingAddToCartServerSideCount(prevCount => {
            if (prevCount === -1) {
                return 1;
            }
            return prevCount + 1;
        });
    };

    const decreaseOngoingCall = () => {
        SetOngoingAddToCartServerSideCount(prevCount => {
            return prevCount - 1;
        });
    };

    const resetOngoingCall = () => {
        SetOngoingAddToCartServerSideCount(-1);
    };

    return {ongoingAddToCartServerSideCount, increaseOngoingCall, decreaseOngoingCall, resetOngoingCall};
};
